import { Error500 } from "../../../alerts/Error";
import WhmcsApi from "../../WhmcsApi";

let signal = null;

export const setSignalDataPayPalPlus = (signal) => {
  signal = signal;
};

export const getDataPayPalPlus = async (invoiceid, token, callbackError = () => {}) => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi

    if (signal) {
      whmcsApi.setSignal(signal);
    }

    const response = await whmcsApi.request(
      "dataPayPalPlus",
      {
        invoiceid,
      },
      "POST",
      token
    );

    return response;
  } catch (error) {
    console.error(error);
    Error500();
    callbackError();
  }

  return false;
};
